<table>
  @if (headers && headers.length) {
    <thead>
      <tr>
        <ng-content select="[gbc-table-header]"></ng-content>
        @if (clickableRows) {
          <th class="chevron-header"></th>
        }
        @if (selectableRows) {
          <th class="selectable-header"></th>
        }
      </tr>
    </thead>
  }
  <tbody>
    <ng-content></ng-content>
  </tbody>
</table>
